<template>
    <Input
        :error="batchError"
        class="mt-3"
        :text="translations.batch_code_desc"
        idAttr="batch"
        :label="translations.enter_batch_code"
        :placeholder="translations.batch_code_placeholder"
        @input="$emit('update:modelValue', $event.target.value)"
        v-model="code"
    />
</template>

<script>
import Input from '@/Components/Input'
export default {
    emits: ['update:modelValue'],
    components: {
        Input,
    },
    props: {
        translations: Object,
    },
    data() {
        return {
            code: null,
            batchError: [],
        }
    },
}

</script>
